import moment from "moment";
import { compact, join } from "lodash";
import { EMPTY } from "constants/common";

export function formatDuration(startedAt?: string, completedAt?: string) {
  if (!startedAt || !completedAt) {
    return EMPTY;
  }

  const start = moment(startedAt);
  const end = moment(completedAt);
  if (!start.isValid() || !end.isValid()) {
    return EMPTY;
  }

  const totalSeconds = end.diff(start, "seconds");
  if (totalSeconds < 0) {
    return EMPTY;
  }

  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  const parts = compact([hours && `${hours}h`, minutes && `${minutes}m`, seconds && `${seconds}s`]);

  return parts.length ? join(parts, " ") : "0s";
}
